// extracted by mini-css-extract-plugin
export default {"main":"Intro_main__XpsSZ","content":"Intro_content__ynEvP","tertiary":"Intro_tertiary__ApLbX"};